import { Autocomplete, Radio, Stack, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { SelectableButton } from "~/modules/app/components/SelectableButton";

import { FeatureCreateOptionArea, FeatureGeometryType } from "../types";
import { MapEditorFeatureCreateOptionsSelect_ProtocolFragment } from "./fragments.generated";

type Props = {
    draftSelectedOption: Partial<FeatureCreateOptionArea>;
    onUpdate: (option: Partial<FeatureCreateOptionArea>) => void;
    protocols: MapEditorFeatureCreateOptionsSelect_ProtocolFragment[];
};

const options: { key: FeatureGeometryType; label: string }[] = [
    {
        key: "Polygon",
        label: "mapEditorFeatureCreateOptions.labelArea",
    },
    {
        key: "LineString",
        label: "mapEditorFeatureCreateOptions.labelRoute",
    },
];

export function PlannerAreaSection({ draftSelectedOption, onUpdate, protocols }: Props) {
    const { t } = useTranslation("mapEditor");

    return (
        <Stack rowGap={1}>
            <Typography variant="subtitle2">{t("mapEditorFeatureCreateDialog.plannerAreaSection.title")}</Typography>
            <Stack direction="row" columnGap={1}>
                {options.map(({ key, label }) => (
                    <SelectableButton
                        key={key}
                        selected={draftSelectedOption.geometryType === key}
                        sx={{ flexGrow: 1, justifyContent: "start", padding: 1, columnGap: 1 }}
                        onClick={() =>
                            onUpdate({
                                ...draftSelectedOption,
                                geometryType: key,
                            })
                        }
                    >
                        <Radio sx={{ padding: 0 }} checked={draftSelectedOption.geometryType === key} />
                        <Typography>{t(label)}</Typography>
                    </SelectableButton>
                ))}
            </Stack>
            {draftSelectedOption.geometryType !== undefined && (
                <Autocomplete
                    multiple
                    value={draftSelectedOption.protocols ?? []}
                    renderInput={params => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label={t("mapEditorFeatureCreateDialog.plannerAreaSection.labelProtocol")}
                        />
                    )}
                    getOptionKey={protocol => protocol.id}
                    getOptionLabel={protocol => protocol.name}
                    options={protocols}
                    onChange={(_event, selectedProtocols) => {
                        onUpdate({
                            ...draftSelectedOption,
                            protocols: selectedProtocols,
                        });
                    }}
                />
            )}
        </Stack>
    );
}
